import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Target04 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="target-04">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5ZM6.5 12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12ZM11 12C11 11.4477 11.4477 11 12 11H12.0797C12.632 11 13.0797 11.4477 13.0797 12V12.0721C13.0797 12.6244 12.632 13.0721 12.0797 13.0721H12C11.4477 13.0721 11 12.6244 11 12.0721V12Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
